module.exports = __webpack_public_path__ + "img/delred.e9c48814.png";